import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api';
import ProjectForm from '../components/ProjectForm';
import Breadcrumbs from '../components/Breadcrumbs';

export default function NewProject() {
  const navigate = useNavigate();
  const location = useLocation();
  const clonedProject = location.state?.project || null;

  async function handleSave(formData) {
    try {
      const result = await api.createProject(formData);
      navigate(`/projects/${result.ProjectId}`);
    } catch (err) {
      alert('Error creating project: ' + err.message);
    }
  }

  return (
    <>
      <div className="top-bar">
        <h2>New Project</h2>
      </div>
      <div className="page-content">
        <Breadcrumbs items={[
          { label: 'Home', path: '/' },
          { label: 'All Projects', path: '/' },
          { label: 'New Project' },
        ]} />
        <div className="card">
          <div className="card-body">
            <ProjectForm project={clonedProject} onSave={handleSave} onCancel={() => navigate('/')} />
          </div>
        </div>
      </div>
    </>
  );
}
